export const FleetIoTSettingConfig = {
  events: {
    name: 'fleet-iot-settings',
    // refresh-index-data
    refresh: `rid-fleet-iot-settings`,
    // slideover-right
    sorId: 'fleet-iot-settings',

    sorOpen: (id) => `sor-open-fleet-iot-settings-${id}`,
    sorClose: (id) => `sor-close-fleet-iot-settings-${id}`,
    sorToggle: (id) => `sor-toggle-fleet-iot-settings-${id}`,
    // editing-data
    editingData: 'edit-fleet-iot-settings-data',
    // viewing-data
    viewingData: 'view-fleet-iot-settings-data',
  },
}
